export default {
  name: "menuSidebar",
  methods: ""
};